import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function product() {
  const parent = document.querySelector('.product');
  if (!parent) return;

  const swiper = new Swiper('.product__swiper', {
    modules: [Navigation, Pagination],
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
